import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import {
  TPrototypePageDto,
  TPrototypePartialDto,
} from '@app-velocity/av-api-v2';

import { useScenarioEvents } from '@app-velocity/modules/scenarios';

import { useHeatMap } from '../../../../../hooks/useHeatMap';

export const useCreateScenarioHeatMap = (
  scenarioId: string,
  workspaceId: string,
  scenarioPages: TPrototypePageDto[],
  scenarioPartials: TPrototypePartialDto[]
) => {
  const { fetchEvents, data } = useScenarioEvents(scenarioId, workspaceId);
  const { generate, clear } = useHeatMap(scenarioPages, scenarioPartials);

  const queryClient = useQueryClient();

  const generateHeatMap = () => {
    fetchEvents();
  };

  useEffect(() => {
    if (!data || data.length === 0) return;

    generate(data);

    queryClient.resetQueries({
      queryKey: ['scenario-events', workspaceId, scenarioId],
    });
  }, [data]);

  return { generateHeatMap, clearHeatMap: clear };
};
